import { withStyles } from '@material-ui/core'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { BlacklistBookingsBase } from './BlacklistBookings'
import { isLoadingSelector } from 'reduxModules/selectors/BlacklistSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isLoading: isLoadingSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export const BlacklistBookings = enhance(BlacklistBookingsBase)



// WEBPACK FOOTER //
// ./src/components/BlacklistBookings/index.js